import ImageComponent from '@components/common/ImageComponent/ImageComponent';
import { TRIM_TOOL } from '@constants/trim-tool';
import {
  BrowserType,
  PlatformType,
} from '@invideoio/web-shared/constants/common';
import { getAppropriateUrl } from '@invideoio/web-shared/utils/common';
import ivclass from '@invideoio/web-shared/Modules/IVClass';
import Head from 'next/head';
import Detail from './Detail';

interface HeroProps {
  platform: PlatformType;
  browser: BrowserType;
  heroSection: any;
}

const HeroSection = (props: HeroProps) => {
  const { platform, heroSection, browser } = props;
  const { desktop, mobile } = TRIM_TOOL.HERO;
  const { plainText, highlightedText, CTAText, CTAUrl, CTASubText, heroImage } =
    heroSection;

  const imageUrl = getAppropriateUrl(heroImage.url, browser, platform);

  return (
    <section
      className={ivclass('iv-overflow-hidden', 'iv-px-20', 'xl:iv-pt-25')}
    >
      <div className={ivclass('iv-container', 'iv-mx-auto')}>
        <div
          className={ivclass(
            'iv-grid',
            'sm:iv-grid-cols-4 md:iv-grid-cols-8 lg:iv-grid-cols-12 xl:iv-grid-cols-12',
            'lg:iv-gap-40 xl:iv-gap-40',
          )}
        >
          <div
            className={ivclass(
              'sm:iv-col-span-4 md:iv-col-span-8 lg:iv-col-start-2 lg:iv-col-end-7 xl:iv-col-start-2 xl:iv-col-end-7',
              'sm:iv-text-center md:iv-text-center lg:iv-text-left xl:iv-text-left',
              'iv-pt-50 lg:iv-pl-15',
            )}
          >
            <Detail
              heading={plainText}
              highlightedText={highlightedText}
              desktop={{
                CTAText: CTAText,
                subInfo: CTASubText,
                CTAUrl,
              }}
              mobile={{ ...mobile, CTAUrl }}
              platform={platform}
            />
          </div>
          <div
            className={ivclass(
              'iv-relative',
              'sm:iv-col-span-4 md:iv-col-span-8 lg:iv-col-span-6 xl:iv-col-span-6',
              'sm:iv-h-[374px] md:iv-h-[476px] lg:iv-h-[580px] xl:iv-h-[740px]',
              'lg:iv-mt-50 xl:iv-mt-50',
            )}
          >
            <div className={ivclass('iv-hero-img')}>
              <div className={ivclass('iv-relative', 'iv-w-[84%] iv-h-full')}>
                <>
                  {/* preloading this image to avoid LCP */}
                  <Head>
                    <link
                      key={'__ivimg-' + imageUrl}
                      rel="preload"
                      as="image"
                      href={imageUrl}
                    />
                  </Head>
                  <ImageComponent
                    elementype="native"
                    src={imageUrl}
                    alt={heroImage.alt}
                    className="iv-object-contain"
                  />
                </>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
